import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { createDtcList } from '../../selectors'
import {
  getSelectedDtcs,
  getDtcOptions,
  getDevicesList,
} from '../../selectors/repairHistory'
import _ from 'lodash'
import { logDeviceProblem } from '../../api/controller-api'
import FaultEditForm from './FaultEditForm'
import { filterDtcs } from './utils'

class DeviceDetails extends Component {
  constructor(props) {
    super(props)
    const isEdit = this.props.item && this.props.item.id
    const isNew = !isEdit
    this.state = {
      isNew,
      isEdit,
      annotation: props.item.annotation,
    }

    const device = this.state.isEdit && {
      label: this.props.item.device_name,
      description: this.props.item.description,
      value: this.props.item.device_name,
      id: this.props.item.device_id,
    }
    this.props.initialize({ item: this.props.item, device: device })
  }

  saveItem = (values) => {
    const {
      item: { id },
      device,
    } = values
    const deviceDtcs = filterDtcs(values.item.dtcs, this.props.dtcOptions)
    const annotation = this.state.annotation
    const reason = values.item.reason.value || values.item.reason
    const deviceName = device.value
    if (this.state.isNew) {
      this.props.add({
        annotation,
        deviceName,
        dtcs: deviceDtcs,
        reason,
      })
    } else {
      this.props.update({
        id,
        annotation,
        deviceName,
        dtcs: deviceDtcs,
        reason,
      })
    }
  }

  updateAnnotations = (annotation) => {
    this.setState({ annotation })
  }

  render = () => (
    <FaultEditForm
      submit={this.props.handleSubmit(this.saveItem)}
      formId={'repair-history-device-details'}
      intl={this.props.intl}
      faults={this.props.faults}
      dtcOptions={this.props.dtcOptions}
      selectedDtcs={this.props.selectedDtcs}
      onClose={this.props.onClose}
      annotations={this.state.annotation}
      updateAnnotation={this.updateAnnotations}
      categorySelectorDetails={{
        label: 'repairHistory.add.form.harnessLabel',
        name: 'device',
        data: this.props.devices,
        placeholder: 'repairHistory.add.form.harnessPlaceholder',
      }}
    />
  )
}

DeviceDetails = reduxForm({
  form: 'repair-history-device-details',
  destroyOnUnmount: true,
})(DeviceDetails)

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: state.modalState.isOpen,
    vehicleTestResultId: _.get(
      ownProps,
      'item.vehicle_test_result_id',
      state.componentState.vehicleTestResultId,
    ),
    makeModelId: state.componentState.makeModelId,
    vin: state.componentState.vin,
    dtcs: createDtcList(state),
    dtcOptions: getDtcOptions(state),
    selectedDtcs: getSelectedDtcs(_.get(ownProps, 'item.dtcs', []))(state),
    faults: [
      ...state.loggingState.faults.device.map((item) => ({
        value: item.key,
        label: item.key,
      })),
      ...state.loggingState.faults.component.map((item) => ({
        value: item.key,
        label: item.key,
      })),
    ],
    devices: getDevicesList(state),
    ...ownProps,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  _add: ({
    annotation,
    vehicleTestResultId,
    componentId,
    dtcs,
    makeModelId,
    reason,
    vin,
    deviceName,
  }) => {
    logDeviceProblem({
      annotation,
      vehicleTestResultId,
      componentId,
      dtcs,
      makeModelId,
      reason,
      vin,
      deviceName,
    })
  },
  _update: ({
    id,
    annotation,
    vehicleTestResultId,
    componentId,
    dtcs,
    makeModelId,
    reason,
    vin,
    deviceName,
  }) => {
    logDeviceProblem({
      id,
      annotation,
      vehicleTestResultId,
      componentId,
      makeModelId,
      vin,
      reason,
      dtcs,
      deviceName,
    })
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    add: (args) => {
      dispatchProps._add({
        ...args,
        vehicleTestResultId: stateProps.vehicleTestResultId,
        makeModelId: stateProps.makeModelId,
        vin: stateProps.vin,
      })
      ownProps.onClose()
    },
    update: (args) => {
      dispatchProps._update({
        ...args,
        vehicleTestResultId: stateProps.vehicleTestResultId,
        makeModelId: stateProps.makeModelId,
        vin: stateProps.vin,
      })
      ownProps.onClose()
    },
  }
}

export const DeviceDetailsContainer = injectIntl(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeviceDetails),
)
